export default __webpack_public_path__ + "static/t60_2-4d7df0d66e9676bb66d5993e17a5bf73.webp";